import React, { useState } from "react"
import { FaEdit, FaTrash } from "react-icons/fa"
import ModalDeleteCompany from "../../../../Modal/ModalDeleteCompany"
import ModalEditCompanyStatus from "../../../../Modal/ModalEditCompanyStatus"
import { parseRankingTable } from "./helpers/parseRankingTable"
import "./../../CompanysForm.css"
import CustomTable from "components/Common/CustomTable"

const RankingTable = ({
  dataArray,
  currentPage,
  setCurrentPage,
  setCompanySelected,
  setShowList,
  totalPages,
}) => {
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false)
  const [isModalEditStatusOpen, setIsModalEditStatusOpen] = useState(false)
  const [companyToEdit, setCompanyToEdit] = useState()

  const handleSelectCompanyToEditStatus = company => {
    setCompanyToEdit(company)
    setIsModalEditStatusOpen(true)
  }

  const handleSelectCompanyToDelete = company => {
    setCompanyToEdit(company)
    setIsModalDeleteOpen(true)
  }

  const handleSelectCompany = company => {
    setCompanySelected(company)
    setShowList(null)
  }

  return (
    <div className="company-table-container">
      {isModalDeleteOpen && (
        <ModalDeleteCompany
          companyId={companyToEdit.Id}
          urlTo={"ranking"}
          setIsModalOpen={setIsModalDeleteOpen}
          setCurrentPage={setCurrentPage}
        />
      )}
      {isModalEditStatusOpen && (
        <ModalEditCompanyStatus
          urlTo={"ranking"}
          setCurrentPage={setCurrentPage}
          setIsModalOpen={setIsModalEditStatusOpen}
          companySelected={companyToEdit}
        />
      )}

      <CustomTable
        data={parseRankingTable({
          data: dataArray,
          onStatusClick: handleSelectCompanyToEditStatus,
          onEditClick: handleSelectCompany,
          onDeleteClick: handleSelectCompanyToDelete,
        })}
        pagination={{
          currentPage,
          onPageChange: setCurrentPage,
          totalPages,
        }}
        autoHeight
      />
    </div>
  )
}

export default RankingTable
